import styled from "styled-components";

// Cartão discreto no Perfil, no mesmo visual do "Dados da conta".
export const Caixa = styled.section`
  margin-top: 8px;
  min-width: 0;
  border-radius: 6px;
  background: #FCFEFC;
  box-shadow: 0px 2px 3px 0px rgba(36, 36, 36, 0.10);
  padding: 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  h3{ margin: 0; font-size: 15px; font-weight: 600; line-height: 150%; color: #1E1F20; }
  p{ margin: 0; font-size: 14px; line-height: 150%; color: #4D4F50; }

  && button.sair-do-perfil{
    align-self: flex-start;
    margin: 6px 0 0 !important;
    height: 38px !important;
    width: auto !important;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid #4D4F50 !important;
    background: transparent !important;
    color: #4D4F50 !important;
    font-family: inherit;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  }
`;
